import { BaseHeading } from "./BaseHeading.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/headings/Heading4.tsx
const Heading4 = ({ children, color = "gray", size = "h4", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(BaseHeading, {
	order: 4,
	size,
	color,
	ta,
	"data-testid": testId,
	children
});

//#endregion
export { Heading4 };